import { useFirstActivationDateMs } from '@atlassian/jira-tenant-context-controller/src/components/first-activation-date-ms/index.tsx';
import { isWithinLast30Days } from '../../utils/is-within-last-30-days/index.tsx';

export const useIsFirstActivationDateWithinLast30Days = () => {
	const firstActivationDate = useFirstActivationDateMs();
	return isWithinLast30Days(firstActivationDate);
};
